import { lazy, type ComponentType } from 'react';
import HomePage from './pages/HomePage';
import { PAGE_META, type PageMetaEntry } from './lib/routeMeta';

// Only the landing page loads eagerly — every other page code-splits so the
// home bundle (the campaign's front door) doesn't carry the register flow,
// admin portal, or legal copy. App.tsx provides the <Suspense> boundary.
const RegisterPage = lazy(() => import('./pages/RegisterPage'));
const BackgroundsPage = lazy(() => import('./pages/BackgroundsPage'));
const RulesPage = lazy(() => import('./pages/RulesPage'));
const PrivacyPage = lazy(() => import('./pages/PrivacyPage'));
const TermsPage = lazy(() => import('./pages/TermsPage'));
const CookiePolicyPage = lazy(() => import('./pages/CookiePolicyPage'));
const PrivacySettingsPage = lazy(() => import('./pages/PrivacySettingsPage'));
const AdminPage = lazy(() => import('./pages/AdminPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

export type AppRoute = {
  path: string;
  Component: ComponentType;
  meta: PageMetaEntry;
};

export const routes: AppRoute[] = [
  { path: PAGE_META.home.path, Component: HomePage, meta: PAGE_META.home },
  { path: PAGE_META.register.path, Component: RegisterPage, meta: PAGE_META.register },
  { path: PAGE_META.backgrounds.path, Component: BackgroundsPage, meta: PAGE_META.backgrounds },
  { path: PAGE_META.rules.path, Component: RulesPage, meta: PAGE_META.rules },
  { path: PAGE_META.privacy.path, Component: PrivacyPage, meta: PAGE_META.privacy },
  { path: PAGE_META.terms.path, Component: TermsPage, meta: PAGE_META.terms },
  { path: PAGE_META.cookies.path, Component: CookiePolicyPage, meta: PAGE_META.cookies },
  {
    path: PAGE_META.privacySettings.path,
    Component: PrivacySettingsPage,
    meta: PAGE_META.privacySettings,
  },
  { path: PAGE_META.admin.path, Component: AdminPage, meta: PAGE_META.admin },
];

export type RouteRedirect = {
  from: string;
  to: string;
};

/**
 * Legacy paths that must keep working. Production shipped with a link to
 * /giveaway baked in, but the entry flow lives at /sweepstakes (renamed from
 * /register per client 2026-07-24) — so /giveaway forwards there instead of
 * dropping those visitors on the 404 page. Query + hash ride along so UTM
 * attribution survives the hop (see components/RedirectRoute.tsx).
 *
 * These paths are deliberately absent from PAGE_META and sitemap.xml: they are
 * forwarding stubs, not pages, and only the destination should be indexed.
 */
export const redirects: RouteRedirect[] = [{ from: '/giveaway', to: PAGE_META.register.path }];

export const notFoundRoute: AppRoute = {
  path: '*',
  Component: NotFoundPage,
  meta: PAGE_META.notFound,
};
